//  Copyright (c) 2020 First Foundry Inc. All rights reserved.

export const PATH = 'notifications/table'
export const SET_PAGE = `${PATH}/SET_PAGE`
export const SET_RESULT = `${PATH}/SET_RESULT`
export const SET_UNSEEN = `${PATH}/SET_UNSEEN`
export const SET_SEARCH_TERM = `${PATH}/SET_SEARCH_TERM`
export const SET_FILTER = `${PATH}/SET_FILTER`
